

export const ConvertDate = (dateString) =>

    // Check if the srting includes the letter T
    dateString.includes("T") ?

        // It does do replace it with a space
        dateString.replace("T", " ")

        // It doesn't so keep the original
        : dateString;



// Convert a datetime string into 'DD MMM YYYY HH:mm' format in the user's local timezone - example 01 Jan 2025 10:34
export const formatDisplayDateTime = (datetimeInput, returnTime = true) => {

    // Handle null/undefined safely
    if (!datetimeInput) return "";

    let date;

    // Handle Date objects
    if (datetimeInput instanceof Date) {

        date = datetimeInput;

    }

    // Handle UTC datetime strings from API
    else if (typeof datetimeInput === "string") {

        // Convert:
        // 2026-06-22 14:09:21
        // into:
        // 2026-06-22T14:09:21Z
        const utcString = datetimeInput
            .replace(" ", "T")
            .replace(/Z?$/, "Z");

        date = new Date(utcString);

    }

    // Invalid input
    else {

        return "";

    }

    // Invalid date
    if (isNaN(date.getTime())) {

        return "";

    }

    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // These are LOCAL values
    const day = String(date.getDate()).padStart(2, "0");
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return (
        <>
            {day} {monthName} {year}

            {returnTime && (
                <>
                    {" "}
                    <span style={{ opacity: 0.7 }}>
                        {hour}:{minute}
                    </span>
                </>
            )}
        </>
    );

};



// Convert 'from' date to API call standard format 'DD-MM-YYYY HH:MM:SS'
export const formatDateFromMidnightString = (date) => {

    return `${date} 00:00:00`;

};

// Convert 'to' date to API call standard format 'DD-MM-YYYY HH:MM:SS'
export const formatDateToMidnightString = (date) => {

    return `${date} 23:59:59`;

};